import { Panel } from 'react-bootstrap';
import Icon from '../../../../../../common/components/Icon/Icon';
import React, { useState } from 'react';

const getFieldsRequired = (validationErrors) => {
  const errorKeys = Object.keys(validationErrors);
  if (!errorKeys.length) {
    return [];
  }

  return errorKeys.filter((key) => !validationErrors[key]);
};

const RequiredFields = ({ status, isValid, validationErrors }) => {
  const [open, setOpen] = useState(false);
  const openClose = () => {
    setOpen(!open);
  };

  if (isValid || status !== 'quote') {
    return null;
  }

  const fieldsRequired = getFieldsRequired(validationErrors);
  return (
    <div className="warning-message-details">
      <Panel
        expanded={open}
        header={
          <h4>
            <strong>More details are required before this policy can be issued</strong>{' '}
            <Icon name={open ? 'minus' : 'plus'} />
          </h4>
        }
        onToggle={openClose}
        onSelect={openClose}
      >
        <div>{fieldsRequired.join(', ') + '.'}</div>
      </Panel>
    </div>
  );
};

export default RequiredFields;
